export function cloneFlatArray<T>(array: T[]): T[] {
  return array?.length ? JSON.parse(JSON.stringify(array)) : [];
}
